import React, { FC, useEffect }     from "react";
import { useDispatch, useSelector } from "react-redux";
import GetCustomer                  from "../../../application/usecase/customer/GetCustomer";
import Customer                     from "../../../domain/customer/Customer";
import { ResKaState }               from "../../../index";
import BackHistoryButton            from "../common/BuckHistoryButton";
import BottomSection                from "../common/layout/BottomSection";
import TopSection                   from "../common/layout/TopSection";
import CustomerForm                 from "./CustomerForm";
import CustomerUpdateButton         from "./CustomerUpddateButton";

const CustomerEdit: FC = () => {
  const customer: Customer = useSelector((state: ResKaState) => state.customer);
  const getCustomer: GetCustomer = new GetCustomer(useDispatch());
  useEffect(() => {
    getCustomer.execute(customer.id)
  }, []);

  return (
    <>
      <TopSection>
        <CustomerUpdateButton/>
        <BackHistoryButton path="/customers"/>
      </TopSection>

      <CustomerForm/>

      <BottomSection>
        <CustomerUpdateButton/>
        <BackHistoryButton path="/customers"/>
      </BottomSection>
    </>
  );
};

export default CustomerEdit;
